import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "swiper/css";
import "swiper/css/navigation";
import "react-loading-skeleton/dist/skeleton.css";
import "../style/offerbanner.css";
import { gettopoffer } from "../service/topoffer.service";
import { getHomeUrl } from "../../../utils/url.utils";

const OfferBanner = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadOffers();
  }, []);

  const loadOffers = async () => {
    try {
      setLoading(true);
      const response = await gettopoffer();
      setBanners(response || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (!loading && !banners.length) return null;

  const showNavigation = banners.length > 1;

  return (
    <section className="offersbanner">
          <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <h2 className="text-lg text-gray-500 mb-2">
             Offers
            </h2>
            <div className="border-bootemline"></div>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="banner-slider position-relative">

          {showNavigation && (
            <>
              <div className="swiper-button-prev custom-nav"></div>
              <div className="swiper-button-next custom-nav"></div>
            </>
          )}

          <Swiper
            modules={[Navigation, Autoplay]}
            navigation={
              showNavigation
                ? {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                  }
                : false
            }
            autoplay={
              showNavigation
                ? {
                    delay: 3000,
                    disableOnInteraction: false,
                  }
                : false
            }
            loop={showNavigation}
          >
            {loading ? (
              <SwiperSlide>
                <Skeleton height={400} />
              </SwiperSlide>
            ) : (
              banners.map((banner) => {
                const image =
                  banner.media?.find(
                    (item) => item.deviceType === "desktop"
                  ) || banner.media?.[0];

                return (
                  <SwiperSlide key={banner.id}>
                    <Link to={getHomeUrl(banner.buttonUrl)}>
                      <img
                        src={image?.image}
                        alt={image?.altText || ""}
                        className="img-fluid w-100"
                        loading="lazy"
                      />
                    </Link>
                  </SwiperSlide>
                );
              })
            )}
          </Swiper>

        </div>
      </div>
    </section>
  );
};
export default OfferBanner;